import {ICON_TYPES} from '../constants';

export const MinimizeScreenIcon = (): JSX.Element => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6 5C6 5.26522 5.89464 5.51957 5.70711 5.70711C5.51957 5.89464 5.26522 6 5 6H0V8H5C5.79565 8 6.55871 7.68393 7.12132 7.12132C7.68393 6.55871 8 5.79565 8 5V0H6V5Z'
        fill='#141414'
      />
      <path
        d='M15.9999 18.9999V23.9999H17.9999V18.9999C17.9999 18.7347 18.1052 18.4803 18.2928 18.2928C18.4803 18.1052 18.7347 17.9999 18.9999 17.9999H23.9999V15.9999H18.9999C18.2042 15.9999 17.4412 16.3159 16.8786 16.8786C16.3159 17.4412 15.9999 18.2042 15.9999 18.9999Z'
        fill='#141414'
      />
      <path
        d='M18.9999 6C18.7347 6 18.4803 5.89464 18.2928 5.70711C18.1052 5.51957 17.9999 5.26522 17.9999 5V0H15.9999V5C15.9999 5.79565 16.3159 6.55871 16.8786 7.12132C17.4412 7.68393 18.2042 8 18.9999 8H23.9999V6H18.9999Z'
        fill='#141414'
      />
      <path
        d='M5 15.9999H0V17.9999H5C5.26522 17.9999 5.51957 18.1052 5.70711 18.2928C5.89464 18.4803 6 18.7347 6 18.9999V23.9999H8V18.9999C8 18.2042 7.68393 17.4412 7.12132 16.8786C6.55871 16.3159 5.79565 15.9999 5 15.9999Z'
        fill='#141414'
      />
    </svg>
  );
};

MinimizeScreenIcon.iconType = ICON_TYPES.MINIMIZE_SCREEN_ICON;
